export default __webpack_public_path__ + "static/media/Brow_5_C5.2409060b.svg";